import isDawn from '../../lib/isDawn'
import isLuna from '../../lib/isLuna'

import SEMANTIC_VERSIONING_REGEX from './SemanticVersioning'

export const firmwareInputValidation = (productName: string, required: boolean) => ({
    ...(required && { required: 'Version number required' }),
    ...(isDawn(productName) || isLuna(productName)
        ? {
              pattern: {
                  value: SEMANTIC_VERSIONING_REGEX,
                  message: 'Version number not valid. Example: 1.1.0',
              },
          }
        : {
              pattern: {
                  value: /^[-\d]\d*$/,
                  message: 'Version number not valid. Example: 830',
              },
          }),
    ...((!isDawn(productName) || isLuna(productName)) && { step: 1 }),
})
